import ImageDialog from "./ImageDialog";

export default ImageDialog;
